import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './armonizacionContable.css';
import './armonizacionContableModern.css';



const principios = [
  
   {
    id:8,
    color: '#a98188',
    title: "Ejercicio fiscal 2026",
     items: [

      
       {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "•	Programación de Presupuesto Anual 5 al Millar",
              url: "/descargables/2026/01 Programación de Presupuesto Anual Presupuesto 5 al Millar/Presupuesto Anual 2026.pdf",
          },
     
        ]
        },


       {
        label: "*Informes Mensuales*",
        
        
        subitems: [
          {
            label: "Enero",
            url: "/descargables/2026/Informes Mensuales 5 al millar/Enero.pdf",
          },
          {
            label: "Febrero",
            url: "/descargables/2026/Informes Mensuales 5 al millar/Febrero.pdf",
          },
          {
            label: "Marzo",
             url: "/descargables/2026/Informes Mensuales 5 al millar/Marzo.pdf",
          },
          {
            label: "Abril",
            url: "/descargables/2026/Informes Mensuales 5 al millar/Abril.pdf",
          },
          {
            label: "Mayo",
             url: "/descargables/2026/Informes Mensuales 5 al millar/Mayo.pdf",
          },
          {
            label: "Junio",
            url: "/descargables/2026/Informes Mensuales 5 al millar/Junio.pdf"
          },
          // {
          //   label: "Julio",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Agosto",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Septiembre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Octubre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },

          // {
          //   label: "Noviembre",
          //   url: "/micro/principio1/codigo_etica_2026.pdf"
          // },
          // {
          //   label: "Diciembre",
          //   url: "/micro/principio1/anexos_codigo_etica.pdf"
          // }
        ]
      },
       {
        label: "*Informes Acumulados*",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "/descargables/2026/Informes Acumulados 5 al millar/Febrero.pdf",
          },
          {
            label: "Marzo",
            url: "/descargables/2026/Informes Acumulados 5 al millar/Marzo.pdf",
          },
          {
            label: "Abril",
             url: "/descargables/2026/Informes Acumulados 5 al millar/Abril.pdf",
          },
          {
            label: "Mayo",
            url: "/descargables/2026/Informes Acumulados 5 al millar/Mayo.pdf",
          },
          {
            label: "Junio",
            url: "/descargables/2026/Informes Acumulados 5 al millar/Junio.pdf",
          },
          // {
          //   label: "Julio",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Agosto",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Septiembre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Octubre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },

          // {
          //   label: "Noviembre",
          //   url: "/micro/principio1/codigo_etica_2026.pdf"
          // },
          // {
          //   label: "Diciembre",
          //   url: "/micro/principio1/anexos_codigo_etica.pdf"
          // }
        ]
      },
     
      //   {
      //   label: "INFORME DE CIERRE ANUAL 2026",
      //   subitems: [
      //     {
      //       label: "•	INFORME CIERRE ANUAL 2026",
      //       url: "/descargables/2026/trimestrales/1er. Informe Trimestral.pdf",
      //     },
          
          
      //   ]
      // },


    
      {
        label: "Conciliaciones Mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
             url: "/descargables/2026/Conciliaciones con la Secretaría de Hacienda/Enero .pdf",
          },
          {
            label: "Febrero",
            url: "/descargables/2026/Conciliaciones con la Secretaría de Hacienda/Febrero.pdf",
          },
          {
            label: "Marzo",
             url: "/descargables/2026/Conciliaciones con la Secretaría de Hacienda/Marzo .pdf",
          },
          {
            label: "Abril",
             url: "/descargables/2026/Conciliaciones con la Secretaría de Hacienda/Abril .pdf",
          },
          {
            label: "Mayo",
            url: "/descargables/2026/Conciliaciones con la Secretaría de Hacienda/Mayo.pdf",
          },
          {
            label: "Junio",
            url: "/descargables/2026/Conciliaciones con la Secretaría de Hacienda/Junio.pdf"
          },
          // {
          //   label: "Julio",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Agosto",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Septiembre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Octubre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },

          // {
          //   label: "Noviembre",
          //   url: "/micro/principio1/codigo_etica_2026.pdf"
          // },
          // {
          //   label: "Diciembre",
          //   url: "/micro/principio1/anexos_codigo_etica.pdf"
          // }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/2026/Conciliaciones Trimestrales con la Secretaría de Hacienda/1er. Informe Trimestral.pdf",
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2026/Conciliaciones Trimestrales con la Secretaría de Hacienda/2do. Informe Trimestral.pdf",
          },
          // {
          //   label: "3er. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "4to. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
        
          
        ]
      },
      
         {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/2026/1 al Millar/1er. Informe Trimestral.pdf",
          },
         {
            label: "2do. Informe Trimestral",
            url: "/descargables/2026/1 al Millar/2do. Informe Trimestral.pdf",
          },
          // {
          //   label: "3er. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "4to. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "INFORME ANUAL 1 AL MILLAR 2025",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          
        ]
      },
     
    ]
  },

  
  
  
  {
    id: 1,
    color: '#621132',
    title: "Ejercicio fiscal 2025.",
    items: [

       {
        label: "Programación de Presupuesto Anual Presupuesto 5 al Millar",
        subitems: [
          // {
          //   label: "Presupuesto Anual 2021",
          //   url: "/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          // },
         
        ]
        },


       {
        label: "*Informes Mensuales*",
         subitems: [
          {
            label: "Enero",
            url: "/descargables/Enero2025mensual.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/Febrero2025mensual.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/Marzo2025mensual.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/Abril2025mensual.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/Mayo2025mensual.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/Junio2025mensual.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/Julio2025mensual.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/Agosto2025mensual.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/Septiembre2025mensual.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/Octubre2025mensual.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/Noviembre2025mensual.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/Diciembre2025mensual.pdf"
          }
        ]
      },
       {
        label: "*Informes Acumulados*",
        subitems: [
          {
            label: "Enero",
            url: ""
          },
          {
            label: "Febrero",
            url: "/descargables/Febrero2025acumulado.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/Marzo2025acumulado.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/Abril2025acumulado.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/Mayo2025acumulado.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/Junio2025acumulado.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/Julioa2025.pdf"
          },
          {
            label: "Agosto",
          url: "/descargables/Agostoa2025.pdf"
          },
          {
            label: "Septiembre",
          url: "/descargables/Septiembrea2025.pdf"
          },
          {
            label: "Octubre",
                url: "/descargables/Octubrea2025.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/Noviembrea2025.pdf"
          },
          {
            label: "Diciembre",
             url: "/descargables/Diciembrea2025.pdf"
          }
        ]
      },

         {
        label: "INFORME DE CIERRE ANUAL 2025 ",
        subitems: [
          {
            label: "INFORME CIERRE ANUAL 2025",
            // url: "/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          },
         
        ]
        },
    
      {
        label: "Conciliaciones mesuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "/descargables/Eneroconciliacion2025.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/Febreroconciliacion2025.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/Marzoconciliacion2025.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/Abrilconciliacion2025.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/Mayoconciliacion2025.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/Juniocon2025.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/Juliocon2025.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/Agostocon2025.pdff"
          },
          {
            label: "Septiembre",
            url: "/descargables/Septiembrecon2025.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/Octubrecon2025.pdf"
          },

          {
            label: "Noviembre",
            url: "/micro/principio1/codigo_etica_2026.pdf"
          },
          {
            label: "Diciembre",
            url: "/micro/principio1/anexos_codigo_etica.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/1%C2%BA%20Trimestre%20Anexo%2011Aconciliacion2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2%C2%BA%20Trimestre%20Anexo%2011A.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/3%C2%BA%20Trimestre%20Anexo%2011A.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/micro/principio1/codigo_etica_2025.pdf"
          },
        
             {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/1er_Informe_Trimestral_2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2do_Informe_Trimestral_2025_M.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/3er_Informe_Trimestral_2025.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: ""
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: ""
          },
          
        ]
      },
        ]
      },
      
     
    ]
  },
  {
    id: 2,
    color: '#9e2348',
    title: "Ejercicio fiscal 2024.",
     items: [

       {
        label: "Programación de Presupuesto Anual 5 al Millar",
        
        
        subitems: [
          {
            label: "Enero",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2024.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/INFORME_MENSUAL_FEBRERO_2024.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_MARZO_2024.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_ABRIL_2024.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_MAYO_2024.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Mensual_junio_2024.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Mensual_julio_2024.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Mensual_agosto_2024.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/Informe_de_Ingresos_y%20_Egresos_Mensual_septiembre_2024.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Mensual_octubre_2024.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/Informe_Mensual_noviembre_2024.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/Informe_Mensual_diciembre_2024.pdf"
          },
           {
            label: "INFORME CIERRE ANUAL 2024",
            url: "/descargables/Informe_de_Cierre_Anual_2024_5MF.pdf"
          }

          
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          {
            label: "Enero",
            url: "/micro/principio1/codigo_etica_2025pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR_2024.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_ACUMULADO_MARZO_5ALMILAR_2024.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_ACUMULADO_ABRIL_5ALMILAR_2024.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_ACUMULADO_MAYO_5ALMILAR_2024.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_junio_2024.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/Informe_de_Ingresos_y%20Egresos_Acumulado_julio_2024.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_agosto_2024.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_septiembre_2024.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_octubre_2024.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/Informe_Acumulado_noviembre_2024.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/Informe_Acumulado_diciembre_2024.pdf"
          }
        ]
      },
    
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "/descargables/CONCILIACION_MENSUAL_ENERO_FEDERAL_2024.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/CONCILIACION_MENSUAL_FEDERAL_FEBRERO_2024.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/CONCILIACION_MARZO_FEDERAL_2024.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/CONCILIACION_ABRIL_FEDERAL_2024.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/CONCILIACION_MAYO_FEDERAL_2024.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_junio_2024.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_julio_2024.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_agosto_2024.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_septiembre_2024.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_octubre_2024.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_noviembre_2024.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_diciembre_2024.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/CONCILIACION_1ER_TRIMESTRE_FEDERAL_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/Conciliaciones_con_la_Secretar%C3%ADa_de_Hacienda_2do._Informe_Trimestral_2024.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/Conciliaciones_con_la_Secretar%C3%ADa_de_Hacienda_3er._Informe_Trimestral_2024.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/Conciliaciones_con_la_Secretar%C3%ADa_de_Hacienda_4to._Informe_Trimestral_2024.pdf"
          },
        
          
        ]
      },
         {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_2do._Trimestre_1_al_Millar.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/Informe_de_Ingresos_y_Egresos_3er._Trimestre_1_al_Millar.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/4to._Informe_Trimestral.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "/descargables/Informe_Anual_1_al_Millar_2024.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  {
    id: 3,
    color: '#a98188',
    title: "Ejercicio fiscal 2023.",
     items: [


       {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual  5 al Millar",
            url: "/descargables/PRESUPUESTO_5ALMILLAR_2023.pdf"
          },
         
        ]
        },

       {
        label: "Informes Mensuales",
          subitems: [
         
          {
            label: "Enero",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2023.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_FEBRERO_2023.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_MARZO_2023.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_ABRIL_2023.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_MAYO_2023.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_JUNIO_2023.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_JULIO_2023.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_AGOSTO_2023.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_SEPTIEMBRE_2023.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_OCTUBRE_2023.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_NOVIEMBRE_2023.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_DICIEMBRE_2023.pdf"
          },
          {
            label: "INFORME CIERRE ANUAL 2023",
            url: "  /descargables/INFORME_CIERRE_ANUAL_2023.pdf"
          },
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
       

          // {
          //   label: "Enero",
          //   url: "/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR_2023.pdf"
          // },
          {
            label: "Febrero",
            url: "/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR_2023.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_ACUMULADO_MARZO_5ALMILAR_2023.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_ACUMULADO_ABRIL_5ALMILAR_2023.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_ACUMULADO_MAYO_5ALMILAR_2023.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_ACUMULADO_JUNIO_5ALMILAR_2023.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_ACUMULADO_JULIO_5ALMILAR_2023.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_ACUMULADO_AGOSTO_5ALMILAR_2023.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_ACUMULADO_SEPTIEMBRE_5ALMILAR_2023.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_ACUMULADO_OCTUBRE_5ALMILAR_2023.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_ACUMULADO_NOVIEMBRE_5ALMILAR_2023.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_ACUMULADO_DICIEMBRE_5ALMILAR_2023.pdf"
          }
        ]
      },
     
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "/descargables/CONCILIACION_ENERO_FEDERAL_2023.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/CONCILIACION_FEBRERO_FEDERAL_2023.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/CONCILIACION_MARZO_FEDERAL_2023.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/CONCILIACION_ABRIL_FEDERAL_2023.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/CONCILIACION_MAYO_FEDERAL_2023.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/CONCILIACION_JUNIO_FEDERAL_2023.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/CONCILIACION_JULIO_FEDERAL_2023.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/CONCILIACION_AGOSTO_FEDERAL_2023.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/CONCILIACION_SEPTIEMBRE_FEDERAL_2023.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/CONCILIACION_OCTUBRE_FEDERAL_2023.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/CONCILIACION_NOVIEMBRE_FEDERAL_2023.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/CONCILIACION_DICIEMBRE_FEDERAL_2023.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/CONCILIACION_1ER_TRIMESTRE_FEDERAL_2023.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/CONCILIACION_2DO_TRIMESTRE_FEDERAL_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/CONCILIACION_3ER_TRIMESTRE_FEDERAL_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/CONCILIACION_4TO_TRIMESTRE_FEDERAL_2023.pdf"
          },
        
          
        ]
      },
      
       {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/INFORME_2DO_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/INFORME_3ER_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/INFORME_4TO_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "/descargables/INFORME_ANUAL_1ALMILLAR_2023.pdf"
          },
          
        ]
      },
    ]
  },
  {
    id:4,
    color: '#a98188',
    title: "Ejercicio fiscal 2022.",
     items: [

        {
        label: "Programación de Presupuesto Anual 5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual 5 al Millar",
            url: "/descargables/PRESUPUESTO_5ALMILLAR_2022.pdf"
          },
         
        ]
        },

        {
        label: "Informes Mensuales",
        
        
        subitems: [
          {
            label: "Enero",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2022.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/INFORME_MENSUAL_5ALMILLAR_FEBRERO_2022.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_MENSUAL_MARZO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_MENSUAL_MAYO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_MENSUAL_JUNIO_2022.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_MENSUAL_JULIO_2022.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_MENSUAL_AGOSTO_2022.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_MENSUAL_SEPTIEMBRE_2022.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_MENSUAL_OCTUBRE_2022.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_MENSUAL_NOVIEMBRE_2022.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_MENSUAL_DICIEMBRE_2022.pdf"
          },
          {
            label: "Informe Cierre",
            url: "/descargables/INFORME_CIERRE_ANUAL_2022.pdf"
          }
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_ACUMULADO_MARZO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_ACUMULADO_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_ACUMULADO_MAYO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_ACUMULADO_ENERO_JUNIO_2022.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_ACUMULADO_ENERO_JULIO_2022.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_ACUMULADO_ENERO_AGOSTO_2022.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_ACUMULADO_ENERO_SEPTIEMBRE_2022.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_ACUMULADO_ENERO_OCTUBRE_2022.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_ACUMULADO_ENERO_NOVIEMBRE_2022.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_ACUMULADO_ENERO_DICIEMBRE_2022.pdf"
          }
        ]
      },
     
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "/descargables/CONCILIACION_ENERO_FEDERAL_2022.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/CONCILIACION_FEBRERO_FEDERAL_2022.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/CONCILIACION_MARZO_FEDERAL_2022.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/CONCILIACION_ABRIL_FEDERAL_2022.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/CONCILIACION_MAYO_FEDERAL_2022.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/CONCILIACION_JUNIO_FEDERAL_2022.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/CONCILIACION_JULIO_FEDERAL_2022.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/CONCILIACION_AGOSTO_FEDERAL_2022.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/CONCILIACION_SEPTIEMBRE_FEDERAL_2022.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/CONCILIACION_OCTUBRE_FEDERAL_2022.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/CONCILIACION_NOVIEMBRE_FEDERAL_2022.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/CONCILIACION_MENSUAL_DICIEMBRE_FEDERAL_2022.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/CONCILIACION_1ER_TRIMESTRE_FEDERAL_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/CONCILIACION_2DO_TRIMESTRE_FEDERAL_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/CONCILIACION_3ER_TRIMESTRE_FEDERAL_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/CONCILIACION_4TO_TRIMESTRE_2022.pdf"
          },
        
          
        ]
      },

        {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/INFORME_1ERTRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/INFORME_2DO_TRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/INFORME_3ERTRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/INFORME_4TO_TRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "/descargables/INFORME_ANUAL_1ALMILLAR_2022.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  {
    id:5,
    color: '#a98188',
    title: "Ejercicio fiscal 2021.",
     items: [
        {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual  5 al Millar",
            url: "/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          },
         
        ]
        },

        {
        label: "Informes Mensuales",
              
        
        subitems: [
          {
            label: "Enero",
            url: "/descargables/INFORME_INGRESOS_EGRESOS_MENSUAL_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_MENSUAL_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_MENSUAL_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_MENSUAL_DICIEMBRE_2021.pdf"
          },
          {
            label: "Informe Cierre",
            url: "/descargables/INFORME_CIERRE_5ALMILLAR_2021.pdf"
          }
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_ACUMULADO_5ALMILLAR_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_ACUMULADO_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_A_JUNIO_2020_5M.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_ACUMULADO_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_ACUMULADO_AGOSTO_2021.pdff"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_ACUMULADO_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_ACUMULADO_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_ACUMULADO_NOVIEMBRE_2021.pdff"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_ACUMULADO_DICIEMBRE_2021.pdf"
          }
        ]
      },
     
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "/descargables/CONCILIACION_FINANZAS_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/CONCILIACION_FINANZAS_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/CONCILIACION%205M%20FEDERAL%20MARZO.pdff"
          },
          {
            label: "Abril",
            url: "/descargables/CONCILIACION_5M_FEDERAL_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/CONCILIACION_MAYO_5ALMILLAR_FEDERAL_2021.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/CONCILIACION_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/CONCILIACION_CONTABILIDAD_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/CONCILIACION_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/CONCILIACION_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/CONCILIACION_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/CONCILIACION_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/CONCILIACION_MENSUAL_DICIEMBRE_2021.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/CONCILIACION%201ER%20TRIMESTRE%205M%20FEDERAL.pdff"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2DO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/3ER_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/4TO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
        
          
        ]
      },
        {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2DO_TRIMESTRE_1_AL_MILLAR.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/3ER_TRIMESTRE_1_AL_MILLAR_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/INFORME_1ALMILLAR_4TO_TRIMESTRE_2021.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "/descargables/INFORME_CIERRE_1ALMILLAR_2021.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  {
    id:6,
    color: '#a98188',
    title: "Ejercicio fiscal 2020.",
     items: [
        {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual  5 al Millar",
            url: "/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          },
         
        ]
        },

        {
        label: "Informes Mensuales",
              
        
        subitems: [
          {
            label: "Enero",
            url: "/descargables/INFORME_INGRESOS_EGRESOS_MENSUAL_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_MENSUAL_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_MENSUAL_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_MENSUAL_DICIEMBRE_2021.pdf"
          },
          {
            label: "Informe Cierre",
            url: "/descargables/INFORME_CIERRE_5ALMILLAR_2021.pdf"
          }
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "/descargables/INFORME_MENSUAL_ACUMULADO_5ALMILLAR_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/INFORME_ACUMULADO_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_A_JUNIO_2020_5M.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/INFORME_ACUMULADO_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/INFORME_ACUMULADO_AGOSTO_2021.pdff"
          },
          {
            label: "Septiembre",
            url: "/descargables/INFORME_ACUMULADO_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/INFORME_ACUMULADO_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/INFORME_ACUMULADO_NOVIEMBRE_2021.pdff"
          },
          {
            label: "Diciembre",
            url: "/descargables/INFORME_ACUMULADO_DICIEMBRE_2021.pdf"
          }
        ]
      },
      
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "/descargables/CONCILIACION_FINANZAS_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "/descargables/CONCILIACION_FINANZAS_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "/descargables/CONCILIACION%205M%20FEDERAL%20MARZO.pdff"
          },
          {
            label: "Abril",
            url: "/descargables/CONCILIACION_5M_FEDERAL_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "/descargables/CONCILIACION_MAYO_5ALMILLAR_FEDERAL_2021.pdf"
          },
          {
            label: "Junio",
            url: "/descargables/CONCILIACION_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "/descargables/CONCILIACION_CONTABILIDAD_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "/descargables/CONCILIACION_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "/descargables/CONCILIACION_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "/descargables/CONCILIACION_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "/descargables/CONCILIACION_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "/descargables/CONCILIACION_MENSUAL_DICIEMBRE_2021.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/CONCILIACION%201ER%20TRIMESTRE%205M%20FEDERAL.pdff"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2DO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/3ER_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/4TO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
        
          
        ]
      },
       {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "/descargables/2DO_TRIMESTRE_1_AL_MILLAR.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "/descargables/3ER_TRIMESTRE_1_AL_MILLAR_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/descargables/INFORME_1ALMILLAR_4TO_TRIMESTRE_2021.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "/descargables/INFORME_CIERRE_1ALMILLAR_2021.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  // {
  //   id:7,
  //   color: '#a98188',
  //   title: "Ejercicio fiscal 2019",
  //    items: [

  //      {
  //       label: "Informes Mensuales",
        
        
  //       subitems: [
  //         {
  //           label: "Enero",
  //           url: "/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2019.pdf",
  //         },
  //         {
  //           label: "Febrero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Marzo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Abril",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Mayo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Junio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Julio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Agosto",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Septiembre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Octubre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },

  //         {
  //           label: "Noviembre",
  //           url: "/micro/principio1/codigo_etica_2026.pdf"
  //         },
  //         {
  //           label: "Diciembre",
  //           url: "/micro/principio1/anexos_codigo_etica.pdf"
  //         }
  //       ]
  //     },
  //      {
  //       label: "INFORME CIERRE ANUAL 2025 ''Informes Acumulados''",
  //       subitems: [
  //         {
  //           label: "Enero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Febrero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Marzo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Abril",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Mayo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Junio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Julio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Agosto",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Septiembre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Octubre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },

  //         {
  //           label: "Noviembre",
  //           url: "/micro/principio1/codigo_etica_2026.pdf"
  //         },
  //         {
  //           label: "Diciembre",
  //           url: "/micro/principio1/anexos_codigo_etica.pdf"
  //         }
  //       ]
  //     },
  //      {
  //       label: "1 al Millar",
  //       subitems: [
  //         {
  //           label: "1er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "2do. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "3er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "4to. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "INFORME ANUAL 1 AL MILLAR 2025",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
          
  //       ]
  //     },
  //     {
  //       label: "Conciliaciones con la Secretaría de Hacienda",
  //       subitems: [
  //         {
  //           label: "Enero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Febrero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Marzo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Abril",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Mayo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Junio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Julio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Agosto",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Septiembre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Octubre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },

  //         {
  //           label: "Noviembre",
  //           url: "/micro/principio1/codigo_etica_2026.pdf"
  //         },
  //         {
  //           label: "Diciembre",
  //           url: "/micro/principio1/anexos_codigo_etica.pdf"
  //         }
  //       ]
  //     },
  //      {
  //       label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
  //       subitems: [
  //         {
  //           label: "1er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "2do. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "3er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "4to. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
        
          
  //       ]
  //     },
      
     
  //   ]
  // },

];




const ArmonizacionContable = () => {
  const [expandedId, setExpandedId] = useState(
    principios[0]?.id ?? null
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAccordion = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const cleanLabel = (label = '') => {
    return label.replace(/\*/g, '').trim();
  };

  return (
    <main className="armonizacion-page">
      <div className="container armonizacion-shell">

        <div className="armonizacion-pill-wrap">
          <div className="armonizacion-pill">
            Recurso Federal 1 y 5 al Millar
          </div>
        </div>

        <div className="armonizacion-heading">
          <h1>EJERCICIOS</h1>
          <span className="armonizacion-heading-line" />
        </div>

        <section
          className="armonizacion-accordion"
          aria-label="Ejercicios fiscales"
        >
          {principios.map((prin) => {
            const isExpanded = expandedId === prin.id;

            const hasDocuments =
              Array.isArray(prin.items) &&
              prin.items.length > 0;

            return (
              <article
                key={prin.id}
                className={`arm-year-card ${
                  isExpanded ? 'is-open' : ''
                }`}
              >
                <button
                  type="button"
                  className="arm-year-header"
                  onClick={() => toggleAccordion(prin.id)}
                  aria-expanded={isExpanded}
                  aria-controls={`arm-panel-${prin.id}`}
                >
                  <span
                    className="arm-year-icon"
                    style={{
                      backgroundColor:
                        prin.color || '#621132'
                    }}
                  >
                    <i className="fa-solid fa-id-card" />
                  </span>

                  <span className="arm-year-title">
                    {prin.title}
                  </span>

                  <span className="arm-year-chevron">
                    <i
                      className={`fa-solid ${
                        isExpanded
                          ? 'fa-chevron-up'
                          : 'fa-chevron-down'
                      }`}
                    />
                  </span>
                </button>

                <div
                  id={`arm-panel-${prin.id}`}
                  className={`arm-panel ${
                    isExpanded ? 'is-open' : ''
                  }`}
                >
                  <div className="arm-panel-inner">
                    {hasDocuments ? (
                      <div className="arm-content-grid">
                        {prin.items.map((item, idx) => {
                          const itemLabel =
                            cleanLabel(item.label);

                          const subitems =
                            Array.isArray(item.subitems)
                              ? item.subitems
                              : [];

                          return (
                            <section
                              className="arm-category"
                              key={`${prin.id}-${idx}`}
                            >
                              <h2 className="arm-category-title">
                                {itemLabel}
                              </h2>

                              {subitems.length > 0 ? (
                                <ul className="arm-doc-list">
                                  {subitems.map(
                                    (subitem, subIdx) => {
                                      const label =
                                        cleanLabel(
                                          subitem.label
                                        );

                                      const hasUrl =
                                        Boolean(
                                          subitem.url &&
                                          subitem.url.trim()
                                        );

                                      return (
                                        <li
                                          key={`${prin.id}-${idx}-${subIdx}`}
                                        >
                                          {hasUrl ? (
                                            <a
                                              href={subitem.url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {label}
                                            </a>
                                          ) : (
                                            <span className="arm-doc-disabled">
                                              {label}
                                            </span>
                                          )}
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              ) : item.url ? (
                                <a
                                  className="arm-single-link"
                                  href={item.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Consultar documento
                                </a>
                              ) : (
                                <p className="arm-empty">
                                  Sin documentos disponibles.
                                </p>
                              )}
                            </section>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="arm-empty arm-empty--panel">
                        No hay documentos disponibles.
                      </p>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </section>
      </div>
    </main>
  );
};

export default ArmonizacionContable;